import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';

export const storeCreditToggledConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.STORE_CREDIT_TOGGLED,
  handler: ({ detail }) => {
    logger('Store Credit Toggled');
    console.log(detail);
  },
};
